import { useState } from "react";
import {  useNavigate } from "react-router-dom";
import { Accordion, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function T8_versionmanager_menu({setactivity, permission, activeItem}) {
  const [isProductionOpen, setProductionOpen] = useState(true); // Predeterminadamente abierto
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };
  return (
    (
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <span role="img" aria-label="devices">🥏</span> Devices Manager
        </Accordion.Header>
        <Accordion.Body className="p-0">
          <Nav className="flex-column">
            <Nav.Link active={activeItem === 'models'} style={activeItem === 'models' ? activeStyles : undefined} onClick={() => navigate('/Models')}>Modelos de TOMi8</Nav.Link>
            <Nav.Link active={activeItem === 'versions'} style={activeItem === 'versions' ? activeStyles : undefined} onClick={() => navigate('/Versions')}>Versiones de apps</Nav.Link>
            <Nav.Link active={activeItem === 'subsistema_tomi'} style={activeItem === 'subsistema_tomi' ? activeStyles : undefined} onClick={() => navigate('/SubsistemaTOMi')}>Subsistema TOMi</Nav.Link>
            {permission === '1' && (
              <>
                <Nav.Link active={activeItem === 'legacy'} style={activeItem === 'legacy' ? activeStyles : undefined} onClick={() => navigate('/Legacy')}>Legacy</Nav.Link>
                <Nav.Link disabled>Radical Lock (no disponible)</Nav.Link>
              </>
            )}
          </Nav>
        </Accordion.Body>
      </Accordion.Item>
    )
  );
}

export default T8_versionmanager_menu;
